import { Deliveries, ImportFile, Rating } from './types';

export const importFileSuccess = (payload: any) => {
  return {
    type: ImportFile.IMPORT_FILE_SUCCESS,
    payload,
  };
};
export const importFileFailure = () => {
  return {
    type: ImportFile.IMPORT_FILE_FAILURE,
  };
};

export const calculateFreightSuccess = (payload: any) => {
  return {
    type: ImportFile.CALCULATE_FREIGHT_SUCCESS,
    payload,
  };
};

export const calculateFreightFailure = () => {
  return {
    type: ImportFile.CALCULATE_FREIGHT_FAILURE,
  };
};

export const showFreight = (payload: any) => {
  return {
    type: ImportFile.SHOW_FREIGHT,
    payload,
  };
};

export const updateDelivery = (payload: Deliveries | undefined) => {
  return {
    type: ImportFile.UPDATE_DELIVERY,
    payload,
  };
};

export const getDeliveries = (payload: Deliveries[]) => {
  return {
    type: ImportFile.GET_DELIVERIES,
    payload,
  };
};

ImportFile.UPDATE_DELIVERY;

export const getRating = (payload: { rating: number; description: string }) => {
  return {
    type: Rating.GET_RATING_DRIVER,
    payload,
  };
};
